// Copyright © 2019-2026 Focal Systems. All rights reserved.

import type * as React from "react";

/** Sushi-2 icon with a plus — used for creating octo rules. */
export function SushiPlusIcon(props: React.ComponentProps<"svg">) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <path d="M15 11c-2-3-5-2-6 0" />
      <path d="M19 16v6" />
      <path d="M2 9v6c0 1.1.6 2.2 1.8 3l3.9 2.7c2.4 1.7 4.3 1.3 5.8 1.3" />
      <path d="M20.3 12.1c2.4-1.7 2.4-4.4 0-6.1l-3.9-2.7a8.23 8.23 0 0 0-8.8 0L3.8 6c-2.4 1.7-2.4 4.4 0 6.1l3.9 2.7c2.4 1.7 5.3 1.7 7.8.7" />
      <path d="M22 19h-6" />
      <path d="M22.1 14V9" />
      <path d="M7.7 10.1c-.9-.6-.9-1.6 0-2.2l2.7-1.8c.9-.6 2.4-.6 3.3 0l2.7 1.8c.9.6.9 1.6 0 2.2l-2.7 1.8c-.9.6-2.4.6-3.3 0z" />
    </svg>
  );
}
